export default "__VITE_ASSET__BSzuirFE__"